/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Field, FieldWrapper, TextWithLink } from '../../../styles';

const CheckboxField = ({ name, isTerms, renderText, renderError = () => {}, ...props }) => {
  const { register, errors } = useFormContext();

  return (
    <FieldWrapper isTerms={isTerms} isCheckbox>
      <Field as='input' ref={register} error={!!errors[name]} type='checkbox' name={name} {...props} />
      <span />
      <TextWithLink>{renderText()}</TextWithLink>
      {renderError({ name, errors })}
    </FieldWrapper>
  );
};

export { CheckboxField };
